import Util from './util';
import AppConsts from './AppConsts';
var SignalRAspNetCoreHelper = /** @class */ (function () {
    function SignalRAspNetCoreHelper() {
    }
    SignalRAspNetCoreHelper.prototype.initSignalR = function () {
        var encryptedAuthToken = abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);
        abp.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + '=' + encodeURIComponent(encryptedAuthToken),
            remoteServiceBaseUrl: Util.ApiUrl,
            startConnection: undefined,
            url: '/signalr'
        };
        Util.loadScript(Util.BaseUrl + '/dist/abp.signalr-client.js');
    };
    return SignalRAspNetCoreHelper;
}());
export default new SignalRAspNetCoreHelper();
